export default "__VITE_ASSET__5b3bbee7__"